module.exports = __webpack_public_path__ + "img/laravel-icon.1cba002b.svg";